module.exports = __webpack_public_path__ + "static/media/trusted-IGB.e3b24a44.png";